import { RoleEnum } from "src/app/modules/shared/models";

export const environment = {
  production: true,
  apiBaseUrl: 'https://siepro.siemens.com/prManagement',
  iTracerApi: 'https://ipep.platform.siemens.cloud/iTracerGRN_Prod/api/data',
  defaultRole : RoleEnum.REQUESTER,
  manualLogin : false,
  rfqModule: 'https://siepro.siemens.com/rfq-client/rfq-creation/stepper?token=',
  poModule: 'https://siepro.siemens.com/po-client/?access_params=',
  prModule: 'https://siepro.siemens.com/prcreation-client/dashboard?access_params=',
  qesModule: 'https://siepro.siemens.com/qes-client/dashboard?access_params=',
  poConfirm : 'https://siepro.siemens.com/confirmation-client/?access_params=',
  domainURL : 'https://ipep.platform.siemens.cloud/'
};
